export default __webpack_public_path__ + "static/media/320x320.ed520e05.jpg";